import axios from 'axios'
import { useAuthStore } from '@/stores/authStore'

// 모든 API 요청의 베이스 경로.
// dev:  .env.development 의 VUE_APP_API_BASE (→ vue.config.js 프록시로 전달)
// prod: .env.production  의 VUE_APP_API_BASE (운영 origin 또는 절대 URL)
// 환경변수 미정의 시엔 '/api' 로 fallback.
export const API_BASE = process.env.VUE_APP_API_BASE || '/'

// 레거시 /node/api/* 엔드포인트(wav, fft, login_ex 등) 베이스.
// 컴포넌트에서 this.URL + 'api/...' 형태로 쓰이므로 끝이 '/' 로 끝나야 함.
//export const NODE_BASE = process.env.VUE_APP_NODE_BASE || 'https://dev.neverlosewater.com/node/'
export const NODE_BASE = process.env.VUE_APP_NODE_BASE || '/'

//export const api = axios.create({ baseURL: NODE_BASE })
export const api = axios.create({ baseURL: NODE_BASE })

// 백엔드에 알리는 실행 환경 (X-NELOW-Env)
//   - {sub}.neverlosewater.com 접속이면 서브도메인 그대로 (dev.neverlosewater.com → dev, kr.neverlosewater.com → kr)
//   - localhost 등 그 밖의 호스트는 .env.development / .env.production 의 VUE_APP_NELOW_ENV (dev / prod)
//   호스트는 페이지가 떠 있는 동안 바뀌지 않으므로 처음 한 번만 계산한다
const NELOW_DOMAIN_SUFFIX = '.neverlosewater.com'
function resolveNelowEnv() {
  const host = (typeof window !== 'undefined' && window.location?.hostname || '').toLowerCase()
  if (host.endsWith(NELOW_DOMAIN_SUFFIX) && host.length > NELOW_DOMAIN_SUFFIX.length) {
    return host.slice(0, -NELOW_DOMAIN_SUFFIX.length)
  }
  return process.env.VUE_APP_NELOW_ENV || ''
}
export const NELOW_ENV = resolveNelowEnv()

// 우리 서버들(공용 api·NRW·AI 채팅·auth_check)에 공통으로 싣는 헤더
//   - Authorization: 로그인 응답의 accessToken(LoginView 가 sessionStorage 에 저장)
//   - X-NELOW-Env : 실행 환경
//   fetch 처럼 axios 인터셉터를 못 타는 호출은 이 함수를 직접 펼쳐 쓴다
export function commonHeaders(token = sessionStorage.accessToken) {
  const headers = {}
  if (token) headers.Authorization = `Bearer ${token}`
  if (NELOW_ENV) headers['X-NELOW-Env'] = NELOW_ENV
  return headers
}

// axios 요청 인터셉터 — 호출부가 직접 지정한 헤더(별도 인증 등)는 덮어쓰지 않는다
export function applyCommonHeaders(config) {
  for (const [k, v] of Object.entries(commonHeaders())) {
    if (!config.headers[k]) config.headers[k] = v
  }
  return config
}

api.interceptors.request.use(applyCommonHeaders)

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const auth = useAuthStore()
      auth.logout()
    }
    return Promise.reject(err)
  },
)
